module.exports = __webpack_public_path__ + "static/img/fenxian2.018f732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fenxian2.png
// module id = eYKI
// module chunks = 1